import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=c2aa31ea&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=c2aa31ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aa31ea",
  null
  
)

export default component.exports